export const falsyRegex = /^(0|n|no|false|off|disabled|falsch|nein)$/i
export const truthyRegex = /^(1|y|yes|true|on|enabled|wahr|ja)$/i
